import { PATH } from '../../../../routes/constant'

export interface INavConfig {
  title: string
  path: string
}

function navConfig (): INavConfig[] {
  return [
    // {
    //   title: 'Home',
    //   path: PATH.HOME
    // },
    // {
    //   title: 'Manage Website',
    //   path: user?.account.websiteUrl ? `${String(user.account.websiteUrl)}/wp-admin/?email=${String(authToken?.login)}&token=${String(authToken?.token)}` : '/manage-website'
    // },
    // {
    //   title: 'Facebook Ads',
    //   path: PATH.ADS
    // },
    {
      title: 'Team',
      path: PATH.TEAM
    },
    {
      title: 'Support',
      path: PATH.SUPPORT
    }
  ]
}

export default navConfig
